import { MapToolWrapperComponent } from '../../mapToolWrapper/mapToolWrapper.component';

type PlacesToolComponentProps = Readonly<{
  isLegendMode: boolean;
}>;

export const PlacesToolComponent = ({
  isLegendMode,
}: PlacesToolComponentProps) => {
  return (
    <MapToolWrapperComponent>
      {!isLegendMode && (
        <div>
          Places Tool
        </div>
      )}
      Places List
    </MapToolWrapperComponent>
  );
};
